import { inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tapResponse } from '@ngrx/operators';
import { signalStoreFeature, withHooks } from '@ngrx/signals';
import { get, isString } from 'lodash';
import { ChatDataService } from 'src/shared/services/chat.data.service/chat.data.service';
import { ChannelService } from 'stream-chat-angular';

export function withRecommendedProductsOnFrozen() {
  return signalStoreFeature(
    withHooks({
      onInit: () => {
        const dataService = inject(ChatDataService);
        const channelService = inject(ChannelService);

        channelService.activeChannel$
          .pipe(
            takeUntilDestroyed(),
            tapResponse({
              next: (channel) => {
                if (!channel) return;
                removeListeners();
                listeners.push(
                  channel.on('channel.updated', (event) => {
                    const chatID = get(event, 'channel.ExtraData.chat_doc_id', null);
                    if (!isString(chatID) || !event.channel?.frozen) return;
                    dataService.HandleChatProductRecommendations(chatID);
                  })
                );
              },
              error: (error) => {
                console.error('Error handling chat product recommendations:', error);
              },
            })
          )
          .subscribe();
      },
      onDestroy: () => {
        removeListeners();
      },
    })
  );
}

let listeners: {
  unsubscribe: () => void;
}[] = [];

const removeListeners = () => {
  if (!listeners || !listeners.length) return;
  listeners.forEach((listener) => listener.unsubscribe());
  listeners = [];
};
